import _ from 'lodash'
import { RANKING, UNASSIGNED } from '../context/types'
import { isVALUE } from '../utils/values/cats'
import { AssessmentDTO } from './types'
// FIXME: use the same convention as database (best, worst)
export const invertRanking = (assessment: AssessmentDTO) => {
    const keys = Object.keys(assessment) as (keyof AssessmentDTO)[]
    keys.forEach((key: keyof AssessmentDTO) => {
        const myv = assessment[key]; // as AssessmentDTO[keyof AssessmentDTO]
        if (typeof myv == 'number' && isVALUE(key) && myv !== UNASSIGNED) {
            // _.set(assessment, key, (10 - myv) as RANKING);
            assessment[key] = (10 - myv) as RANKING; //not-assignable-to-parameter-of-type-never-error
            console.log('### invertRanking for: ', key, myv, 'to', assessment[key])
        } else {
            console.debug(`### invertRanking: ${myv} is not a ranking for ${key}, skipped`)
        }
    })
    return assessment
}

export const nullifyUnassigned = (assessment: AssessmentDTO) => {
    const keys = Object.keys(assessment) as (keyof AssessmentDTO)[]
    keys.forEach((key: keyof AssessmentDTO) => {
        const myv = assessment[key]; 
        if (typeof myv == 'number' && isVALUE(key) && myv === UNASSIGNED) {
            assessment[key] = 0 as any;
            console.log('### removeUnassigned for: ', key, myv, 'to', assessment[key])
        } 
    })
    return assessment
}